import { MatTabsConfig } from '@angular/material/tabs';

export const tabsConfig: MatTabsConfig = {
  animationDuration: '0ms',
};
